import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import config from '../config';
import litnetLogo from '../assets/images/Litnet.png';

const Logo = ({ width = 100, compact = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (compact && config.logoIcon) {
    return (
      <img
        src={`${process.env.PUBLIC_URL || ''}${config.logoIcon}`}
        alt="LITNET"
        width={34}
        height={34}
        style={{ display: 'block', borderRadius: 8, objectFit: 'contain' }}
      />
    );
  }

  return (
    <img
      src={litnetLogo}
      alt="LITNET"
      width={compact ? 46 : width}
      style={{
        display: 'block',
        height: 'auto',
        filter: isDark ? 'brightness(0) invert(0.93)' : 'none'
      }}
    />
  );
};

Logo.propTypes = {
  width: PropTypes.number,
  compact: PropTypes.bool
};

export default Logo;